import { HiPencil } from "react-icons/hi2"
import { Link } from "@tanstack/react-router"
import { Button } from "~/components/ui/button"
import { UserProfile } from "~/components/user-profile"
import { useUser } from "../hooks/use-user"
import { LogoutButton } from "./logout-button"

export function MyProfile() {
  const { data: user } = useUser()

  if (!user) return null

  return (
    <UserProfile user={user}>
      <Button variant="overlay-icon" size="icon-sm" asChild>
        <Link to="/profile/edit">
          <HiPencil />
        </Link>
      </Button>
      <LogoutButton />
    </UserProfile>
  )
}
